;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('publicFolder', publicFolder)

  function publicFolder () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        collection: '<',
        buttons: '=',
        sending: '='
      },
      templateUrl: '/arts/directives/public-folder/public-folder-directive.html?$$REVISION$$',
      controller: 'PublicFolderController'
    }
  }
})()
